import { css } from '@emotion/react';

export const modal = {
  overlay: {
    backgroundColor: 'rgba(0,0,0, 0.5)',
    zIndex: 10000,
  },
  content: {
    top: 0,
    left: '50%',
    right: 0,
    bottom: 0,
    width: '100%',
    maxWidth: '768px',
    border: 0,
    padding: 0,
    background: 'transparent',
    borderRadius: 0,
    transform: `translate(-50%, 0)`,
  },
};

export const wrap = css`
  width: 100%;
  height: 100%;
`;

export const content = css`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  background-color: white;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;
